import React from 'react';

// Define types for the props
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave ?: () => void;
  title: string;
  content: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, onSave, title, content }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <div className='flex justify-between'>
        <h2 className="text-lg font-semibold">{title}</h2>
        <button onClick={onClose} className="text-white p-2 rounded">
        <svg width="20" height="20" viewBox="0 0 40 40"><path d="M 10,10 L 30,30 M 30,10 L 10,30" stroke="black" strokeWidth="4" /></svg>
          </button>
        </div>
        <div>{content}</div>
        <div className="mt-4 text-right">
          <button onClick={onSave} className="bg-blue-500 text-white p-2 rounded">
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
